'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bind(operation, context) {
  return operation.bind(context);
}

/**
 * Sets a function's `this` context. Similar to `Function.prototype.bind`.
 *
 * @example
 * bind(console.log, console);
 *
 * @param {Function} operation
 * @param {Object} context
 * @return {Function}
 */
exports.default = (0, _curry2.default)(bind);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/bind.js
// module id = 340
// module chunks = 0 1